import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-044c92ae"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Inicie o cronometro para desbloquear!")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_objective_title = _resolveComponent("objective-title")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_expansion_item = _resolveComponent("q-expansion-item")!
  const _component_objective_item = _resolveComponent("objective-item")!
  const _component_q_list = _resolveComponent("q-list")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_loading_container = _resolveComponent("loading-container")!
  const _component_q_card = _resolveComponent("q-card")!

  return (_openBlock(), _createBlock(_component_q_card, {
    class: "relative-position shadow-10",
    "data-cy": "objective-card"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_objective_title, {
        class: "text-justify",
        info: _ctx.objective.info,
        difficulty: _ctx.objective.b,
        qNumeration: _ctx.qNumeration,
        feedback: _ctx.feedback,
        "data-cy": "objective-info",
        onSendReport: _ctx.sendReport
      }, null, 8, ["info", "difficulty", "qNumeration", "feedback", "onSendReport"]),
      _createVNode(_component_q_separator),
      (_ctx.objective.text_associated)
        ? (_openBlock(), _createBlock(_component_q_card_section, {
            key: 0,
            class: "limit-img-size image-wrap text-center",
            "data-cy": "objective-text-associated",
            innerHTML: _ctx.objective.text_associated
          }, null, 8, ["innerHTML"]))
        : _createCommentVNode("", true),
      (_ctx.objective.text_associated)
        ? (_openBlock(), _createBlock(_component_q_separator, { key: 1 }))
        : _createCommentVNode("", true),
      _createVNode(_component_q_card_section, {
        class: _normalizeClass(["limit-img-size image-wrap", { "blurry-text": _ctx.isPaused }]),
        innerHTML: _ctx.objective.enunciation,
        "data-cy": "objective-enunciation"
      }, null, 8, ["innerHTML", "class"]),
      (_ctx.showComments)
        ? (_openBlock(), _createBlock(_component_q_separator, { key: 2 }))
        : _createCommentVNode("", true),
      (_ctx.showComments)
        ? (_openBlock(), _createBlock(_component_q_expansion_item, {
            key: 3,
            "switch-toggle-side": "",
            "expand-separator": "",
            icon: "comment",
            label: "Visualizar Comentários",
            style: {"background-color":"rgb(255 240 62 / 20%)"}
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", {
                class: "q-pa-md text-justify",
                innerHTML: _ctx.objective.bestcomment
              }, null, 8, _hoisted_1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_q_separator),
      _createVNode(_component_q_card_section, { class: "no-padding" }, {
        default: _withCtx(() => [
          _createVNode(_component_q_list, {
            class: "border-radius-inherit",
            separator: ""
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.alternatives, (item, index) => {
                return (_openBlock(), _createBlock(_component_objective_item, {
                  "data-cy": `objective-alternatives-${index}`,
                  letter: item,
                  text: ((_ctx.objective.alternatives[item as keyof(Alternative)]) as string),
                  feedback: _ctx.feedback,
                  correct: _ctx.objective.correct_answer,
                  marked: _ctx.marked,
                  onResponse: _ctx.setResponse,
                  context: _ctx.context
                }, null, 8, ["data-cy", "letter", "text", "feedback", "correct", "marked", "onResponse", "context"]))
              }), 256))
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      (_ctx.isPaused)
        ? (_openBlock(), _createBlock(_component_q_tooltip, {
            key: 4,
            class: "bg-negative",
            type: "error",
            anchor: "bottom middle",
            self: "top middle"
          }, {
            default: _withCtx(() => [
              _hoisted_2
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_loading_container, { loading: _ctx.loading }, null, 8, ["loading"])
    ]),
    _: 1
  }))
}